import { Vue, Component, Prop } from 'vue-property-decorator';
import { ref } from 'vue';
import { topicListAPI } from '@/providers/apis/topic-list/topic-list';
import { AUDIENCE_TYPE, TOOL_CATEGORY } from '@/utils/constants';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import CreateTopic from '@/components/create-topic/create-topic';
import DeleteTopic from '@/components/delete-topic/delete-topic';

@Component({
    name: 'topic-list',
    components: {
        'create-topic': CreateTopic,
        'delete-topic': DeleteTopic,
    },
})
export default class NudgeTypesPageComponent extends Vue {
    public searchAccessList: string = '';
    public searchLoader = false;
    public showPopup = false;
    public selectedTopic: any = null;
    public classification: any;
    public debouncedSearchAccess = this.debounce(
        this.searchAccess.bind(this),
        300,
    );
    @Prop({ default: () => [] })
    public selectedList!: any;

    public isLoading: boolean = true;
    public listCount: any = null;
    public offset: number = 0;
    public limit: number = 20;
    public isCreateTopic: boolean = false;
    public isEditTopic: boolean = false;
    public subjectList: any;
    public levelList: any = [];
    public selectedOption: any = null;
    public openDropdownList = false;
    public selectedSubject: any = null;
    public openLevelList: boolean = false;
    public isDeleteTopic: boolean = false;
    showDeletePopup: boolean = false;
    isDeleted: boolean = false;
    public get filtersCount() {
        const selectedList = this.selectedList;
        return Object.values(selectedList).reduce((total, item: any) => total + item.length, 0);
    }
    public filterList: any = {
        category: {
            name: 'Category',
            selectedItems: [],
            key: 'category',
            items: [],
            textField: 'title',
            valueField: 'id',
        },
        subject: {
            name: 'Subject',
            selectedItems: [],
            key: 'subject',
            items: [],
            textField: 'title',
            valueField: 'id',
        },
        grades: {
            name: 'Grades',
            selectedItems: [],
            key: 'grades',
            items: [],
            textField: 'grade',
            valueField: 'id',
            multiSelect: true,
        },
        audience: {
            name: 'Audience',
            selectedItems: [],
            key: 'audience',
            items: AUDIENCE_TYPE,
            textField: 'text',
            valueField: 'value',
        },
        toolCateogry: {
            name: 'Tool Categories',
            selectedItems: [],
            key: 'toolCateogry',
            items: TOOL_CATEGORY,
            textField: 'text',
            valueField: 'value',
            multiSelect: true,
        },
    };
    public topicList: any = [];
    public tenantList: any = [];
    public recentSelectedParent: any = this.filterList.category;
    public currentPage: number = 1;
    public menuItems: any = [];
    public openDropdown: boolean = false;
    public selectedSubjectIndex: number | null = null;
    public selectedLevelIndex: number | null = null;
    public subjectOptions: any = [];
    public levelOptions: any[] = [];
    public fields: any = [
        { key: 'topicname', label: 'Topic Name' },
        { key: 'subjectname', label: 'Subject Name' },
        // { key: 'tenant', label: 'Tenants' },
        { key: 'category', label: 'Category' },
        { key: 'grade', label: 'Grade / Level' },
        { key: 'sequence', label: 'Sequence' },
        { key: 'actions', label: 'Actions' },
    ];
    public filterItems: any = [
        {
            name: 'Marker Type',
            key: 'markertype',
            isVisible: true,
            options: [{
                title: 'Auto Marker',
                value: 'auto-marker',
            },
            {
                title: 'Marker',
                value: 'marker',
            },
            ],
            isSelected: false,
        },
        {
            name: 'Subject',
            key: 'subject',
            isVisible: true,
            options: [],
            isSelected: false,
        },
    ];
    public async onSelectMenu(selectedItem: any, value: any) {
        this.$emit('changeOffset', 0);
        const selectedValue = value.title || value.grade || value.name || value;
        this.selectedOption = {
            ...this.selectedOption,
            [selectedItem.key]: selectedValue,
        };
        selectedItem.isSelected = true;
        const selectedOption = selectedItem.options.find((item: any) => item.title === selectedValue);
        this.fetchTopics();
    }
    public searchAccess() {
        const trimmedSearch = this.searchAccessList.trim();
        if (trimmedSearch && trimmedSearch.length > 3) {
            this.searchLoader = true;
            this.searchLoader = false;
        }
    }
    public async created() {
        this.fetchTopics();
        this.subjectList = await topicListAPI.getSubjects();
        const subjectObject = this.filterItems.find((item: any) => item.key === 'subject');
        subjectObject.options = this.subjectList;
        this.tenantList = await topicListAPI.getTenants();
    }

    public searchAccessListClear() {
        this.searchAccessList = '';
        this.isLoading = false;
        this.searchLoader = false;
    }
    public debounce(func: (...args: any[]) => void, delay: number) {
        let timer: any;
        return function(this: NudgeTypesPageComponent, ...args: any[]) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }
    public onGoBack(isDeleted: boolean) {
        this.showPopup = false;
        this.isEditTopic = false;
        this.openDropdownList = false;
        this.showDeletePopup = false;
        this.isDeleted = isDeleted;
        if(this.isDeleted) {
            this.fetchTopics();
        }
    }
    public async toggleDropdown(index: any, item: any) {
        this.openDropdownList = true;
        if (item.subject_code) {
            this.selectedSubjectIndex = index;
            this.selectedSubject = item;
            await this.onSubjectSelect(item, index);
        } else if (item.type === 'level') {
            this.selectedOption = {
                ...this.selectedOption,
                [item.type]: item.key,
            };
            this.openDropdownList = false;
            this.fetchTopics();
        }
    }

    public async onSubjectSelect(subject: any, index: number) {
        this.selectedSubjectIndex = index;
        this.selectedLevelIndex = null;
        this.levelOptions = [];
        this.openLevelList = false;
        this.$set(subject, 'children', []);

        try {
            const levels = await topicListAPI.getLevels(subject.key);
            this.levelOptions = levels.map((level: any) => ({
                value: level.grade_id,
                text: level.title,
                type: 'level',
                key: level.key,
            }));
            this.$set(subject, 'children', this.levelOptions);
            this.openLevelList = true;
        } catch (error) {
            this.levelOptions = [];
            this.$set(subject, 'children', []);
            this.openLevelList = false;
        }
    }

    public onLevelSelect(level: any, index: number) {
        this.selectedLevelIndex = index;
        this.$emit('level-selected', {
            subject: this.subjectOptions[this.selectedSubjectIndex!],
            level,
        });
    }
    public async clearSelection(key: any) {
        this.openDropdownList = false;
        const filterItem = this.filterItems.find((item: any) => item.key === key);
        if (filterItem) {
            filterItem.isSelected = false;
        }
        if (this.selectedOption && this.selectedOption[key]) {
            this.$delete(this.selectedOption, key);
        }
        if (key === 'subject') {
            this.selectedSubject = null;
            this.selectedSubjectIndex = null;
            this.levelOptions = [];
            const levelFilter = this.filterItems.find((item: any) => item.key === 'level');
            if (levelFilter) {
                levelFilter.isSelected = false;
            }
            if (this.selectedOption && this.selectedOption.level) {
                this.$delete(this.selectedOption, 'level');
            }
        }
        await this.fetchTopics();
    }
    public async fetchTopics() {
        this.fetchClassification();
        const skip = this.offset;
        const limit = this.limit;
        const filterParams: any = {};

        if (this.selectedOption && this.selectedOption.markertype) {
            filterParams.auto_marker = this.selectedOption.markertype === 'auto-marker';
        }

        if (this.selectedOption && this.selectedOption.level) {
            filterParams.level_id = this.selectedOption.level;
        }
        const params: any = {
            skip,
            limit,
            ...filterParams,
        };
        await topicListAPI.getTopics(params).then((topics: any) => {
            this.topicList = topics.list;
            const transformedList = this.topicList.map((item: any) => {
                const subjectCodeRaw = item.subjects && item.subjects.length > 0 ? item.subjects[0].code : '-';
                const subjectCodePrefix = subjectCodeRaw.split('.')[0] || '';
                const matchedClassification = this.classification.find(
                    (cls: any) => cls.code === subjectCodePrefix,
                );
                return {
                    id: item.marker_id,
                    topicname: item.name,
                    subjectname: item.subjects && item.subjects.length > 0 ? item.subjects[0].name : '-',
                    // tenant: 'Gooru',
                    subject: item.subjects,
                    category: matchedClassification ? matchedClassification.title : '-',
                    grade: item.levels && item.levels.length > 0 ? item.levels[0].name : '-',
                    sequence: item.sequence,
                };
            });

            this.topicList = transformedList;
            this.listCount = topics.listCount;
            this.isLoading = false;
        });
    }

    public createTopic() {
        this.showPopup = true;
        this.selectedTopic = null;
    }

    public editTopic(selectedTopic: any) {
        this.selectedTopic = selectedTopic;
        this.isEditTopic = true;
        this.showPopup = true;
    }

    public deleteTopic(selectedTopic: any) {
        this.selectedTopic = selectedTopic;
        this.showDeletePopup = true;
        this.isDeleteTopic = true;
    }

    public onSelectPage(pageNumber: number) {
        window.scrollTo(0, 0);
        this.currentPage = pageNumber;
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.fetchTopics();
    }

    public async fetchClassification() {
        await tenantSettingsAPI.fetchClassifications().then((res: any) => {
            this.classification = res;
        });
    }

}
